import { forgotPassword } from "./account/forgotPasswordSlice";
import { login } from "./account/loginSlice";
import { validateToken } from "./account/validateTokenSlice";
import { getNotifications } from "./account/getNotificationsSlice";
import { getNotices } from "./account/getNoticesSlice";
import { changeNotifications } from "./account/changeNotificationsSlice";
import { settingsSlice } from "./settingsSlice";

import { listCategories } from "./pricing/listCategoriesSlice";
import { listCompanies } from "./pricing/listCompaniesSlice";
import { listHeadliners } from "./pricing/listHeadlinersSlice";
import { listVenues } from "./pricing/listVenuesSlice";
import { queryInventory, queryInventorySlice } from "./pricing/queryInventorySlice";

import { listCustomers } from "./sales/listCustomersSlice";
import { querySales, querySalesSlice } from "./sales/querySalesSlice";

import mapSlice from "./map/mapSlice";
import { getActiveListings } from "./marketplace/seatgeek/getActiveListingsSlice";
import { getEventMap, getEventMapSlice } from "./marketplace/seatgeek/getEventMapSlice";
import { getLowestComparables } from "./marketplace/seatgeek/getLowestComparables";
import { getSoldListings } from "./marketplace/seatgeek/getSoldListingsSlice";
import { getPOSSettings, getPOSSettingsSlice } from "./pos/getPOSSettingsSlice";
import { updatePOSSettings } from "./pos/updatePOSSettingsSlice";
import { appendListingNotes } from "./pricing/appendListingNotes";
import { updateListingExternalNotes } from "./pricing/updateListingExternalNotes";
import { disableFlashSale } from "./pricing/disableFlashSale";
import { getListingSharedSettings, getSharedSettings } from "./pricing/getSharedSettings";
import { holdTickets } from "./pricing/holdTicketsSlice";
import { updateSharing } from "./pricing/listingsSharing";
import { queryEventInventoryAll, queryEventInventoryAllSlice } from "./pricing/queryEventInventoryAllSlice";
import { queryGlobalInventory, queryGlobalInventorySlice } from "./pricing/queryGlobalInventorySlice";
import { queryEvents, queryEventsSlice } from "./pricing/queryEventsSlice";
import { releaseListings } from "./pricing/releaseListings";
import { holdListings } from "./pricing/holdListings";
import { deleteRule, getSavedRules, saveRule } from "./pricing/savedRulesSlice";
import { selectionSlice } from "./pricing/selectionSlice";
import {
	settingsSlice as pricingSettingsSlice,
	setEventColumns,
	setInventoryColumns,
	setUngroupedInventoryColumns,
} from "./pricing/settingsSlice";
import { updateSplitListing } from "./pricing/splitListings";
import { updateSplitListingAdvanced } from "./pricing/splitListingsAdvanced";
import { updateFlashSale } from "./pricing/updateFlashSale";
import { updateListingCosts } from "./pricing/updateListingCosts";
import { updateListingPosition } from "./pricing/updateListingPosition";
import { updateListingPositionBulk } from "./pricing/updateListingPositionBulk";
import { updateListingPrices } from "./pricing/updateListingPrices";
import { acceptEventPrices } from "./pricing/acceptEventPrices";
import { updateSchedulePrice } from "./pricing/updateSchedulePrice";
import { getListingsItems, getListingsItemsSlice, listingsItemsSlice } from "./purchasing/getListingsItemsSlice";
import { updatePurchaseInfo } from "./purchasing/updatePurchaseInfo";
import { updateListingInHand } from "./purchasing/updateListingInHand";
import { createExternalInvoice } from "./sales/createExternalInvoice";
import { createExternalInvoiceBulk } from "./sales/createExternalInvoiceBulk";
import { createInvoice } from "./sales/createInvoice";
import { createPayment } from "./sales/createPayment";
import { cancelInvoice } from "./sales/cancelInvoice";
import { createAdjustment } from "./sales/createAdjustment";
import { deleteAdjustment } from "./sales/deleteAdjustment";
import { listAdjustmentOrganizations } from "./sales/listAdjustmentOrganizations";
import { listAdjustmentOrganizationSubcategories } from "./sales/listAdjustmentOrganizationSubcategories";
import { listExchanges } from "./sales/listExchanges";
import { fetchEventSummary } from "./pricing/getEventSummary";

import { listStates } from "./system/ListStatesSlice";
import { viewItemHistory } from "./system/ViewHistory";
import { addEventTags } from "./system/addEventTagsSlice";
import { addItemTags } from "./system/addItemsTagsSlice";
import { attachPdfs } from "./system/attachPdfs";
import { deletePdfs } from "./system/deletePdfs";
import { editTickets } from "./system/editTickets";
import { forceAttachPdfs } from "./system/forceAttachPdfs";
import { getEventTags } from "./system/getEventTags";
import { getFile } from "./system/getFile";
import { getSeats, getSeatsSlice } from "./system/getGetSeats";
import { getItemPng } from "./system/getItemPng";
import { getListingTags } from "./system/getListingTags";
import { listAllTags } from "./system/listAllTagsSlice";
import { listCommonHelp } from "./system/listCommonHelpSlice";
import { listExportDestinations } from "./system/listExportDestinationsSlice";
import { listLocations } from "./system/listLocationsSlice";
import { removeEventTag } from "./system/removeEventTag";
import autopricerSlice, { saveRules, setListingRules } from "@src/store/auto-pricer/autopricerSlice";
import { removeTag } from "./system/removeTag";
import { splitPDFs } from "./system/splitPDFs";
import { supportAttachmentRequest } from "./system/supportAttachmentRequest";
import { updateCostPerTicket } from "./system/updateCostPerTicket";
import { getListingRulesSlice, getQuickActionListingRules } from "./auto-pricer/getListingRulesSlice";
import { removeAutopricer } from "./auto-pricer/removeAutopricerSlice";
import { getSeasonInventory } from "./auto-pricer/getSeasonInventory";
import { fetchSales } from "./sales/salesSlice";
import { getActiveChartsPlus } from "./marketplace/seatgeek/getChartActiveDataPlus";
import { getSoldChartsPlus } from "./marketplace/seatgeek/getChartSoldDataPlus";
import { createFulfillmentHelpRequest, createHelpAndSupportTicket } from "./system/helpAndSupportSlice";
import { createContactUserEmail } from "./system/contactUserSlice";
import { getSyncLogs } from "./pricing/syncLogs";
import { getTNActiveListings } from "./marketplace/ticketsNow/getTNActiveListingsSlice";
import { getTicketNetworkActiveListings } from "./marketplace/ticketNetwork/getTNActiveListingsSlice";
import { changeTicketsSeatNumbers, forceChangeTicketsSeatNumbers } from "./pricing/changeSeatNumbersSlice";
import { relistListings } from "./pricing/relistListings";
import { reviewedListingsSlice } from "./pricing/reviewedListingsSlice";
import { editTicketStock } from "./pricing/editTicketStock";
import { duplicateListings } from "./pricing/duplicateListings";
import { queryDuplicateListingEvents } from "./pricing/duplicateListingEventsSlice";
import { queryNewPoEvents, updateNewPoEvents, resetNewPoEvents } from "./pricing/queryNewPoEventsSlice";
import { createPurchaseOrder } from "./purchasing/createPurchaseOrder";
import { listPoCategories } from "./purchasing/listPoCategoriesSlice";
import { listPoHeadliners } from "./purchasing/listPoHeadlinersSlice";
import { listPoVenues } from "./purchasing/listPoVenuesSlice";
import { getGametimeSales } from "./marketplace/gameTime/getSoldListingsGameTime";
import { getGametimeListings } from "./marketplace/gameTime/getActiveListingsGameTime";
import { deleteListingThunk } from "./pricing/deleteListing";
import { credentialStatisticsSlice, getCredentialStatistics } from "./passwordManager/getCredentialStatistics";
import { credentialsSlice, getCredentials } from "./passwordManager/getCredentials";
import { companiesSlice, getCompanies } from "./passwordManager/getCompanies";
import { companyAutoPOSlice, getCompanyAutoPO } from "./passwordManager/getCompanyAutoPO";
import { missingInformationCountSlice, getMissingInformationCount } from "./autoPo/getMissingInformationCount";
import { updateNotes } from "./passwordManager/updateNotes";
import { getPassword, setCachedPassword, clearCachedPassword } from "./passwordManager/getPassword";
import { updateNotificationEmail } from "./passwordManager/updateNotificationEmail";
import { deleteNotificationEmail } from "./passwordManager/deleteNotificationEmail";
import { updateEnableNotifications, updateEnableNotificationsSlice } from "./passwordManager/updateEnableNotifications";
import { updatePassword } from "./passwordManager/updatePassword";
import { addNewCredential } from "./passwordManager/addNewCredential";
import { checkUser } from "./passwordManager/checkUser";
import { getVendors, vendorsSlice } from "./passwordManager/getVendors";
import { getVendorParents, vendorParentsSlice } from "./passwordManager/getVendorParents";
import { getVendorsFullData, vendorsFullDataSlice } from "./passwordManager/getVendorsFullData";
import { getPropagationPreview, propagationPreviewSlice } from "./passwordManager/getPropagationPreview";
import { getCompanyPersona, resetCompanyPersona } from "./passwordManager/getCompanyPersona";
import { updateCompanyPersona } from "./passwordManager/updateCompanyPersona";
import { getCredentialPersona, resetCredentialPersona } from "./passwordManager/getCredentialPersona";
import { updateCredentialPersona } from "./passwordManager/updateCredentialPersona";
import { getResetStatuses } from "./passwordManager/getResetStatuses";
import { triggerPasswordReset } from "./passwordManager/triggerPasswordReset";
import { bulkUploadCredentials } from "./passwordManager/bulkUploadCredentials";
import { deleteCredential } from "./passwordManager/deleteCredential";
import { refreshPasswordManagerToken } from "./passwordManager/refreshPasswordManagerToken";
import { createVendor } from "./passwordManager/createVendor";
import { getNotes } from "./passwordManager/getNotes";
import { updateVendor } from "./passwordManager/updateVendor";
import { deleteVendor } from "./passwordManager/deleteVendor";
import { queryUserNotificationsSlice } from "./system/queryUserNotifications";
import { getBalance } from "./creditCard/getBalanceSlice";

export const accountActions = {
	login,
	forgotPassword,
	validateToken,
	getNotifications,
	getNotices,
	changeNotifications,
};

export const marketplaceActions = {
	seatgeek: {
		getEventMap,
		...getEventMapSlice.actions,
		getLowestComparables,
		getActiveListings,
		getSoldListings,
		getActiveChartsPlus,
		getSoldChartsPlus,
	},
	ticketsNow: {
		getTNActiveListings,
	},
	ticketNetwork: {
		getTicketNetworkActiveListings,
	},
	gameTime: {
		getGametimeSales,
		getGametimeListings,
	},
};

export const posActions = {
	getPOSSettings,
	updatePOSSettings,
	...getPOSSettingsSlice.actions,
};

export const pricingActions = {
	listCategories,
	listCompanies,
	listHeadliners,
	listVenues,
	acceptEventPrices,
	fetchEventSummary,
	updateListingPrices,
	updateListingPosition,
	updateListingPositionBulk,
	updateListingCosts,
	updateFlashSale,
	updateSplitListing,
	updateSplitListingAdvanced,
	disableFlashSale,
	updateSchedulePrice,
	...getSharedSettings.actions,
	queryEventInventoryAll,
	getSavedRules,
	saveRule,
	deleteRule,
	updateSharing,
	getListingSharedSettings,
	...queryEventInventoryAllSlice.actions,
	queryGlobalInventory,
	...queryGlobalInventorySlice.actions,
	queryEvents,
	...queryEventsSlice.actions,
	queryInventory,
	...queryInventorySlice.actions,
	...pricingSettingsSlice.actions,
	setEventColumns,
	setInventoryColumns,
	setUngroupedInventoryColumns,
	holdTickets,
	appendListingNotes,
	updateListingExternalNotes,
	releaseListings,
	holdListings,
	relistListings,
	...reviewedListingsSlice.actions,
	editTicketStock,
	duplicateListings,
	queryDuplicateListingEvents,
	queryNewPoEvents,
	updateNewPoEvents,
	resetNewPoEvents,
	getSyncLogs,
	changeTicketsSeatNumbers,
	forceChangeTicketsSeatNumbers,
	deleteListingThunk,
};

export const eventActions = {
	...selectionSlice.actions,
};

export const mapActions = {
	...mapSlice.actions,
};

export const salesActions = {
	listCustomers,
	createExternalInvoice,
	createExternalInvoiceBulk,
	createInvoice,
	createPayment,
	cancelInvoice,
	createAdjustment,
	deleteAdjustment,
	listAdjustmentOrganizations,
	listAdjustmentOrganizationSubcategories,
	listExchanges,
	querySales,
	...querySalesSlice.actions,
	fetchSales,
};

export const purchasingActions = {
	getListingsItems,
	updatePurchaseInfo,
	updateListingInHand,
	createPurchaseOrder,
	listPoCategories,
	listPoHeadliners,
	listPoVenues,
	...getListingsItemsSlice.actions,
	...listingsItemsSlice.actions,
};

export const systemActions = {
	listAllTags,
	listCommonHelp,
	listExportDestinations,
	listLocations,
	listStates,
	viewItemHistory,
	addItemTags,
	addEventTags,
	editTickets,
	getListingTags,
	getEventTags,
	removeEventTag,
	removeTag,
	splitPDFs,
	attachPdfs,
	getFile,
	getSeats,
	...getSeatsSlice.actions,
	getItemPng,
	deletePdfs,
	forceAttachPdfs,
	supportAttachmentRequest,
	updateCostPerTicket,
	createHelpAndSupportTicket,
	createFulfillmentHelpRequest,
	createContactUserEmail,
	...queryUserNotificationsSlice.actions,
};

export const settingsActions = {
	...settingsSlice.actions,
};

export const creditCardActions = {
	getBalance,
};

export const autopricerActions = {
	...autopricerSlice.actions,
	setListingRules,
	saveRules,
	...getListingRulesSlice.actions,
	getQuickActionListingRules,
	removeAutopricer,
	...getListingRulesSlice.actions,
	...getSeasonInventory.actions,
};

export const passwordManagerActions = {
	getCredentialStatistics,
	getCredentials,
	getCompanies,
	getCompanyAutoPO,
	updateNotes,
	getPassword,
	setCachedPassword,
	clearCachedPassword,
	updateNotificationEmail,
	deleteNotificationEmail,
	updateEnableNotifications,
	updatePassword,
	getVendors,
	getVendorsFullData,
	getVendorParents,
	addNewCredential,
	checkUser,
	bulkUploadCredentials,
	deleteCredential,
	createVendor,
	updateVendor,
	deleteVendor,
	getNotes,
	getPropagationPreview,
	refreshPasswordManagerToken,
	getCompanyPersona,
	resetCompanyPersona,
	updateCompanyPersona,
	getCredentialPersona,
	resetCredentialPersona,
	updateCredentialPersona,
	getResetStatuses,
	triggerPasswordReset,
	...credentialStatisticsSlice.actions,
	...credentialsSlice.actions,
	...companiesSlice.actions,
	...companyAutoPOSlice.actions,
	...vendorsSlice.actions,
	...vendorsFullDataSlice.actions,
	...vendorParentsSlice.actions,
	...propagationPreviewSlice.actions,
	...updateEnableNotificationsSlice.actions,
};

export const autoPoActions = {
	getMissingInformationCount,
	...missingInformationCountSlice.actions,
};
